module.exports = __webpack_public_path__ + "static/media/camera.bfc43a65.svg";